import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import logo from "../../assets/images/logo1.png";

const navItems = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Features", id: "features" },
  { label: "Team", id: "team" },
  { label: "Contact Us", id: "footer" }, // ✅ footer based
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("home");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const lockRef = useRef(false);

  /* ✅ HANDLE RESIZE */
  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
      setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  /* ✅ SCROLL DETECTION (CONTACT FIXED) */
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);

      if (lockRef.current) return;

      const scrollPos = window.scrollY + window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;

      // ✅ CONTACT US (FOOTER)
      if (pageHeight - scrollPos < 180) {
        setActive("footer");
        return;
      }

      // ✅ OTHER SECTIONS
      for (let item of navItems) {
        if (item.id === "footer") continue;

        const el = document.getElementById(item.id);
        if (!el) continue;

        const rect = el.getBoundingClientRect();
        if (rect.top <= 140 && rect.bottom >= 140) {
          setActive(item.id);
          return;
        }
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* ✅ CLICK SCROLL */
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    lockRef.current = true;
    setActive(id);
    el.scrollIntoView({ behavior: "smooth" });
    setOpen(false);

    setTimeout(() => {
      lockRef.current = false;
    }, 800);
  };

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: scrolled ? 0.96 : 1 }}
      transition={{ duration: 0.4 }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: scrolled
          ? "rgba(8,23,40,0.94)"
          : "rgba(8,23,40,0.82)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      {/* BAR */}
      <div
        style={{
          maxWidth: "1320px",
          margin: "0 auto",
          padding: scrolled ? "12px 20px" : "16px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* LOGO */}
        <div
          onClick={() => scrollToSection("home")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
            color: "white",
          }}
        >
          <img
            src={logo}
            alt="MSC Natraj"
            style={{ height: scrolled ? 36 : 40 }}
          />
          <span
            style={{
              fontSize: isMobile ? "14px" : "18px",
              fontWeight: 600,
              whiteSpace: "nowrap",
            }}
          >
            MSC Natraj
          </span>
        </div>

        {/* DESKTOP MENU */}
        {!isMobile && (
          <nav style={{ display: "flex", gap: "32px" }}>
            {navItems.map((item) => {
              const isActive = active === item.id;

              return (
                <div
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    color: isActive
                      ? "#60a5fa"
                      : "rgba(255,255,255,0.9)",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  {item.label}

                  {/* ACTIVE LINE */}
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      bottom: "-6px",
                      height: "2px",
                      width: isActive ? "100%" : "0%",
                      background:
                        "linear-gradient(90deg,#60a5fa,#2563eb)",
                      transition: "width 0.25s ease",
                    }}
                  />
                </div>
              );
            })}
          </nav>
        )}

        {/* MOBILE ICON */}
        {isMobile && (
          <div
            onClick={() => setOpen(!open)}
            style={{
              fontSize: 22,
              cursor: "pointer",
              color: "white",
            }}
          >
            ☰
          </div>
        )}
      </div>

      {/* MOBILE MENU */}
      {isMobile && open && (
        <div
          style={{
            background: "rgba(8,23,40,0.97)",
            padding: 22,
            display: "flex",
            flexDirection: "column",
            gap: 16,
            color: "white",
          }}
        >
          {navItems.map((item) => (
            <div
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              style={{ cursor: "pointer" }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
